<template>
  <layout :operation="'security-center'"></layout>
</template>

<script>
import Layout from "@/views/front/jsf35/operations";

export default {
  name: "SecurityCenter",
  components: {
    Layout,
  },
};
</script>

<style lang="scss" scoped></style>
